import React, { useState } from 'react'

import {
  DialogOverlay,
  DialogOverlayActions,
  DialogOverlayFooter,
  Button,
  Checkbox,
  Separator,
  useStatusOverlay,
} from '@fs/zion-ui'
import { gql, useMutation } from '@apollo/client'
import { NoticeLoading } from '@fs/zion-icon/dist/cjs/icons'
import transl from './Watermarking.transl'
import fsOperationsCallHeader from '../../../../../../utils/fsOperationsCallHeader'

export const removeWatermarkMutation = gql`
  mutation RemoveWatermark($groupApids: [String]) {
    dasToDas(groupApids: $groupApids, dgsSet: null, watermarkId: "", expectedAction: "REMOVE_WATERMARK") {
      code
      success
      message
    }
  }
`

/**
 * RemoveWatermarkDialog component allows users to remove watermarks from selected image groups.
 *
 * NOTE: This component works similarly to the RemoveWatermarkDialog component in lightyear-react.
 *    If you make changes here, ensure they are also reflected in lightyear-react.
 */
export default function RemoveWatermarkDialog({ overlay, groupId }) {
  const [removeWatermark, { loading: removeWatermarkLoading }] = useMutation(removeWatermarkMutation)
  const showStatusOverlay = useStatusOverlay()
  const [checked, setChecked] = useState(false)

  async function handleRemoveWatermark() {
    try {
      const result = await removeWatermark({
        variables: {
          groupApids: [groupId],
        },
        context: { headers: { ...fsOperationsCallHeader } },
      })

      if (result.data.dasToDas.success) {
        showStatusOverlay({
          message: transl.removeWatermarkSuccess(),
          type: 'success',
          dismissable: true,
        })
        overlay.close()
      } else {
        showStatusOverlay({
          message: transl.removeWatermarkFailure(result.data.dasToDas.message),
          type: 'error',
          dismissable: true,
        })
      }
    } catch (error) {
      showStatusOverlay({
        message: transl.removeWatermarkError(),
        type: 'error',
        dismissable: true,
      })
      console.error('Error removing watermark:', error)
    }
  }
  return (
    <DialogOverlay title={transl.removeWatermarks()} {...overlay}>
      {transl.removeWatermarksDescription()}
      <Separator size="xxs" />
      <Checkbox
        label={transl.iUnderstand()}
        name="understandAgreement"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="cancelRemoveWatermarking" emphasis="low" onClick={overlay.handleClick}>
            {transl.cancel()}
          </Button>
          <Button
            data-testid="sendRequestToRemoveWatermarking"
            Icon={removeWatermarkLoading ? NoticeLoading : null}
            emphasis="high"
            disabled={!checked || removeWatermarkLoading}
            onClick={handleRemoveWatermark}
          >
            {transl.apply()}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
